var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal",
      attrs: {
        id: _vm.id,
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true",
        "data-keyboard": "false",
        "data-backdrop": "static"
      }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-md", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", { staticClass: "modal-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("apps.inventory.message.binlocation")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: { click: _vm.onClose }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "div",
                {
                  staticClass: "row",
                  staticStyle: { "max-height": "60vh", "overflow-y": "auto" }
                },
                _vm._l(_vm.form.items, function(item, index) {
                  return _c("div", { key: index, staticClass: "col-12 mb-2" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        {
                          staticStyle: { flex: "1" },
                          on: {
                            click: function($event) {
                              return _vm.onClickItem(index)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c("span", { staticClass: "input-group-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "apps.inventory.message.bincodenumberorlocation"
                                    )
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.code,
                                  expression: "item.code"
                                }
                              ],
                              class: [
                                "form-control text-right",
                                {
                                  "is-invalid": _vm.isDuplicated(
                                    index,
                                    item.code
                                  )
                                }
                              ],
                              domProps: { value: item.code },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(item, "code", $event.target.value)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "invalid-feedback text-right" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "apps.inventory.message.bincodecannotbedupplicated"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center align-items-center",
                          staticStyle: { width: "40px" }
                        },
                        [
                          _vm.form.items.length - 1 !== index
                            ? _c(
                                "BaseButton",
                                {
                                  attrs: { className: "no-bg" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onOpenModal(index)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "far fa-trash-alt" })]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-light",
                  attrs: { type: "button" },
                  on: { click: _vm.onCancel }
                },
                [_vm._v(_vm._s(_vm.$t("button.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-web",
                  attrs: { disabled: _vm.duplicated, type: "button" },
                  on: { click: _vm.onSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("button.apply")))]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("baseConfirmDeleteModal", {
        attrs: {
          show: _vm.modal.show,
          loading: _vm.modal.loading,
          description: _vm.$t("apps.inventory.message.confirmdeletebinlocation")
        },
        on: {
          onClose: _vm.handleCloseModal,
          onCancel: _vm.handleCancleModal,
          onSubmit: _vm.handleSumitModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-181307e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-181307e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseBinLocationModal.vue
// module id = null
// module chunks = 